export class CreateProjectCouponModel {
    couponCode: string;
    couponCalcType: number;
    couponDiscountValue: number;
    couponStartDate: string;
    couponEndDate?: string;
    couponCompanyQuotaLimit?: number;
    couponQuotaLimit?: number;
    couponMinimumDiscount: number;
    couponMaximumDiscount?: number;
    couponPackageCondition?: Array<number>;
    createUserId: number;
    couponDescription: string;
    projProdSurrKey: number;
}

export class ResponseCouponModel {
    couponCode: string;
    couponSurrKey: number;
    message: string;
    statusCode: number;
}

export class CouponItemModel {
    couponSurrKey: number;
    createUserId: number;
    couponCode: string;
    couponCalcType: number;
    couponDiscountValue: number;
    couponStartDate: Date;
    couponEndDate?: Date;
    couponCompanyQuotaLimit?: number;
    couponQuotaLimit?: number;
    couponMinimumDiscount: number;
    couponMaximumDiscount?: number;
    couponPackageCondition?: Array<number>;
    couponDescription: string;
    projProdSurrKey: number;
    projProdName: string;
    isActive: boolean;
    couponCount: number;
    isDelete: boolean;
    couponType?: number;
    couponCompanyUseds?: Array<CouponCompanyUsedModel>;
    createBy?: string;
}

export class CouponListModel {
    itemList: Array<GroupCouponModel>;
    pageNumber: number;
    pageSize: number;
    totalItemCount: number;
    totalPageCount: number;
}

export class CouponListQueryModel {
    textSearch: string;
    pageNumber: number;
    pageSize: number;
    sortColumn: string;
    sortByDesc: boolean;
    couponType: number;
}

export class GroupCouponModel {
    projProdSurrKey: number;
    projProdName: string;
    itemList: Array<CouponItemModel>;
    isShow: boolean;
}

export class CreateProjectFreeCouponModel {
    couponCode: string;
    couponStartDate: string;
    couponEndDate?: string;
    couponQuotaLimit?: number;
    couponPackageCondition?: Array<number>;
    createUserId: number;
    couponDescription: string;
    projProdSurrKey: number;
}

export class CouponCompanyUsedModel {
  companySurrKey: number;
  companyName: string;
  usedDate: Date;
}
